<template>
<!-- <List :searchText="searchText" :plantIdList="" :deviceIdList="" ref="List"></List> -->
<div>
	
	<Confirm ref="Confirm"></Confirm>
	<!--<DeviceDetail ref="ViewDetail" @Dels='deletes' @showStations="showStation" @DeviceUpgrades="deviceUpgrade" @DeviceControls="deviceControl"  @closePage="closePage"  @refresh="refresh" @update="getList()"></DeviceDetail>-->
	<ViewDetail :type="type" ref="ViewDetail"></ViewDetail>
	<!-- 高级筛选 -->
	<FilterAdv @SearchList="searchList" v-if="filter" :plantIdLists="plantIdList" :type="type" :alarmObjSelect="alarmObjSelect" :powerTypeList="powerTypeList" ref="FilterAdv"></FilterAdv>
	<!-- :targetId="returnTargetId" -->
	<!-- <WindowForAlert :title="$t('cmd140',['高级筛选'])" :size="'m'" ref="WindowForAlert">
		<table class="emptyToken_EE">
			<thead class="head-token">
				<tr>
					<th class="w8x"></th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th class="cSub" :title="$t('word728',['电站类型'])">{{$t('word728',['电站类型'])}}</th>
					<td class="lh15 mr1x_E curP_E">
						<label><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="null">{{$t('cmd19',['全部'])}}</label>
						<label v-for="plant in getTypeText('','plantType',true)" :key="plant.id[0]"><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="plant.id[0]">{{plant.name}}</label>
					</td>
				</tr>
				<tr>
					<th class="cSub" :title="$t('word736',['并网类型'])">{{$t('word736',['并网类型'])}}</th>
					<td class="lh15 mr1x_E curP_E">
						<label><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="null">{{$t('cmd19',['全部'])}}</label>
						<label v-for="grid in getTypeText('','plantGridType',true)" :key="grid.id[0]"><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="grid.id[0]">{{grid.name}}</label>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="toolBar bdSub-top">
			<button class="functionBtn close" @click="getList(filterAdvTemp,'filterAdv')" :title="$t('cmd12',['确定'])" type="button">{{$t('cmd12',['确定'])}}</button>
		</div>
	</WindowForAlert> -->
	<div class="filter mt1x mMeduce">
		<div class="tableSys mb1x vaM_E">
			<div class="pl1x mr05x_E dpIB_E vaM_E">
				<div class="mr2x" type="button">{{$t("alert1",[statusCount.total,"共{0}个报警"])}}</div>
				<Select v-if="getTimeFilter.length" :class="{'active':filterQuick.timeFilter.active!=getTimeFilter[0].value}" :bindActive="filterQuick.timeFilter.active" :list="getTimeFilter" :size="type?'m':'s'" :styleType="'showAll'" :displayFilter="displaySelectTime" @Click="index=>selectAction(index,'timeFilter')">
					<div slot="static">
						<div class="pl1x pt05x pb05x fSub hover-bg-highLight hasDropList-hover vaM_E">
							<span>{{$t('cmd234',['选择月'])}}</span>
							<Icon name="arrow-r" class="w1x h1x" :sizeBase="'xxs'" />
							<vue-datepicker-local v-model="filterQuick.timeFilter.targetMonth" class="dropList" format="YYYY/MM" type="inline" clearable></vue-datepicker-local>
							<!--  :disabled-date="disabledDate" -->
						</div>
					</div>
				</Select>
				<Help v-if="type&&userFor!=='device'&&['i','h'].indexOf(getTimeFilter[0].value)>=0" :code="'alert-timeFilter-current'" :btnClose="false"></Help>
				<Help v-else-if="['i','h'].indexOf(getTimeFilter[0].value)>=0" :code="'alert-timeFilter-current-device'" :btnClose="false"></Help>
				<!-- <button class="fSub pl1x pr1x hover-f-main tra-fast" @click="openFilterAdv" :title="$t('cmd140',['高级筛选'])" type="button"><Icon name="filter" class="w1x h1x" /></button> -->
				<InputText v-if="type===1" class="w20x dpIB bgContent" :placeholder="getLanguageStr('phrase706','输入报警名称')" :clearBtn="true" :searchBtn="true" v-model="searchTextInner" name="alarmSearchTextInner" :fn="searchKey" @AfterClear="afterClear" ref="searchBox"></InputText>
				<button class="fSub pl1x pr1x hover-f-main" :title="$t('cmd140',['高级筛选'])" @click="openFilterAdv" type="button"><Icon name="filter" class="ico w1x h1x mr5"/></button>
			</div>
			<!--
			<div class="w20x pr1x taR">
				<div class="classGroup cb cField_E bdSub_E">
					<button :class="{active:listMode==='list'}" type="button">{{$t("plant_list71",["列表"])}}</button>
					<button :class="{active:listMode==='map'}" type="button">{{$t("creat_plant29",["地图"])}}</button>
				</div>
			</div>
			 -->
		</div>
		<div class="filterArea bgContent pb1x bdSub-bottom dpN">
			<transition-group name="" class="tagList cb fL_E ml1x_E mt1x_E ofH_E" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
				<TagBox v-for="(tag,key) in tagMap" :key="key" class="show" :title="filterAdv[tag.key].name" :val="filterAdv[tag.key].tagKey?getTypeText(tag.val,filterAdv[tag.key].tagKey):tag.val"
					@Remove="getList( {[tag.key]:{active:filterAdv[tag.key].def}} ,'filterAdv')"></TagBox>
				<button class="cField sizeS" :key="0" @click="getList('clear')" type="button">{{$t("cmd258",["清空筛选"])}}</button>
			</transition-group>
		</div>
	</div>
	<div class="alarmList tableScope bgContent">
		<div class="table table-5x posR" fillHeight="lastHeight,-.alarmList .tableBatch">
			<Loading ref="Loading"></Loading>
			<div v-show="list!=null && pagination.total>0" class="cb">
				<div class="scrollHide tra-fast bdLight-right fL"
					 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					 scrollFloatX="false">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<!-- <div class="w4x"></div> -->
						<div :title="getLanguageStr('word1745','报警名称')">{{getLanguageStr("word1745","报警名称")}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" @click.stop="openD(obj, sourceType)">
								<!-- 
								<td class="selectColumn w4x">
									<Checkbox v-model="plant.isSelect" :index="index" @Click="selectData"></Checkbox>
								</td>
								 -->
								<td class="curP">
									<div :title="obj.showName">{{obj.showName}} /ID {{obj.ruleId}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!-- 
				<div class="operate scrollHide" fillHeight="lastHeight,-.tableBatch" :mode="stage.setting.loc.operateMode" v-show="moreBtnFlag">
					<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
						<div class="cb vaM_E">
							<button class="fa fa-angle-double-right hover-c-main" :title="$t('cmd108',['点击展开/收起'])" @click="operateModeChange" type="button"></button>
							<span class="dpIB lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<thead class="head-token">
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(plant,index) in data" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
									<button v-permissions="'A/D/B'" permission-type="none" class="hover-f-follow" type="button" @click="_follow(plant.id,index)" :title="plant.isFollowed?'解除关注':$t('关注',['关注'])">
										<Icon :name="plant.isFollowed?'star-on':'star-off'" :class="{'fFollow':plant.isFollowed}" class="ico"/>
									</button>
									<button v-permissions="'A/D/B'" permission-type="none" class="hover-f-main" type="button" @click="$emit('AddRelevant',plant.id)" :title="$t('manage76',['成员'])">
										<Icon name="link" class="ico"/>
									</button>
									<button v-permissions="'A/D/B'" permission-type="none" class="hover-f-main" type="button" @click="$emit('AddPlantTag',plant.id)" :title="$t('标签',['标签'])">
										<Icon name="tag" class="ico"/>
									</button>
									<button v-permissions="'A/B/C'" permission-type="none" class="hover-f-main" type="button" @click="$emit('Edit',plant.id)" :title="$t('cmd8',['编辑'])">
										<Icon name="ico-edit-o" class="ico"/>
									</button>
									<button v-permissions="'A/B/D'" permission-type="none" class="hover-c-error hover-f-error" type="button" @click="$emit('Del',plant.id)" :title="$t('cmd9',['删除'])">
										<Icon name="ico-recycle" class="ico"/>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				 -->
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						 scrollFloatY="false">
						 <div :class="{cMain:orderProperty=='level'}" class="sequence taC" :title="$t('word115',['等级'])" @click="onOrder('level')">
							<span>{{$t("word115",["等级"])}}</span>
							<span :sequence="orderProperty=='level'? orderDirection:''"></span>
						</div>
						<div :title="getLanguageStr('word1481','影响范围')">{{getLanguageStr('word1481','影响范围')}}</div>
						<div v-if="'plant' == sourceType" :title="getLanguageStr('word204','电站')" class="w30pct">{{getLanguageStr('word204','电站')}}</div>
						<div v-if="'plant' == sourceType" :title="getLanguageStr('device62','设备')">{{getLanguageStr('device62','设备')}}</div>
						<div :class="{cMain:orderProperty=='alertTime'}" class="sequence w14x" :title="getLanguageStr('word1482','最后触发时间')" @click="onOrder('alertTime')">
							<span>{{getLanguageStr('word1482','最后触发时间')}}</span>
							<span :sequence="orderProperty=='alertTime'? orderDirection:''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" class="tra-fast_E">
								<td :title="getTypeText(obj.level,'alarmLevel')[0]" class="taC">
									<div :class="[getTypeText(obj.level,'alarmLevel')[2],{'bgBall':stage.languageId=='zh'},{'bgEllipticBall':stage.languageId!='zh'}]"><span>{{getTypeText(obj.level,'alarmLevel')[0]}}</span></div>
								</td>
								<td :title="getTypeText(obj.influence,'alarmInfluenceScope')[0]" :class="getTypeText(obj.influence,'alarmInfluenceScope')[1]">{{getTypeText(obj.influence,'alarmInfluenceScope')[0]}}</td>
								<td v-if="'plant' == sourceType" class="w30pct">{{obj.stationName}}</td>
								<td v-if="'plant' == sourceType&&(obj.deviceName||obj.deviceType)" :title="(obj.deviceName||getTypeText(obj.deviceType,'deviceType'))+' '+obj.deviceSn||''">
									{{obj.deviceName||getTypeText(obj.deviceType,'deviceType')}}<div class="cSub" :title="obj.deviceSn?obj.deviceSn:'--'">{{obj.deviceSn?obj.deviceSn:'--'}}</div>
								</td>
								<!-- <td v-else-if="'plant' == sourceType&&obj.deviceType!=null&&obj.deviceSn!=null" :title="(getTypeText(obj.deviceType,'deviceType'))+(obj.deviceSn)"> -->
								<td v-else-if="'plant' == sourceType" :title="'--'">
									--
								</td>
								<td :title="displayTime(obj.alertTime,'%Y/%m/%d %H:%M:%S',obj.timezone)" class="w14x">
									<div v-if="obj.alertTime">{{displayTime(obj.alertTime,'%H:%M:%S',obj.timezone)}}</div>
									<div v-if="obj.alertTime" class="cSub">{{displayTime(obj.alertTime,'%Y/%m/%d UTC',obj.timezone)}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<no-result v-show="!list"></no-result>
		</div>
		<div class="tableBatch bgContent cSub" :class="{disable:!list}">
			<!-- <Checkbox :text="$t('cmd91',['全选'])" :status="selectAllStatus" :triggerClick="false" @Click="selectData"></Checkbox> -->
			<Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
			<!-- <button class="bdSub hover-bg-highLight" :class="{disable:selectQty==0}" type="button" @click="_delBatch">{{$t('cmd27',['批量删除'])}}</button> -->
			<!-- <button class="bdSub hover-bg-highLight" :class="{disable:selectQty==0}" type="button" @click="associate" v-permissions="'A/D/B'">{{$t('cmd44',['批量关联'])}}</button> -->
			<!-- <div class="fR mt05x">{{$t('word56',['已选'])+": ("+selectQty+")"}}</div> -->
		</div>
	</div>
	<div ref='view'></div>
</div>
</template>
<script>
import {getLanguageStr} from "@/util/language";
import * as lib from "@/util/lib.js";

import StatusIco from "@/components/common/ui/StatusIco.vue";
import TagBox from "@/components/common/ui/TagBox.vue";
import InputText from "@/components/common/ui/InputText.vue";
import AreaInput from "@/components/common/ui/AreaInput.vue";
import Select from "@/components/common/ui/Select.vue";
import Checkbox from "@/components/common/ui/Checkbox.vue";
import Pagination from "@/components/common/ui/Pagination.vue";
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading';
import Help from "@/components/common/Help.vue";
import WindowForAlert from "@/components/common/ui/WindowForAlert.vue";
import FilterAdv from "@/view/maintain/alarm/part/FilterAdv.vue";
import Confirm from "@/components/common/ui/Confirm.vue";
import ViewDetail from "@/view/maintain/alarm/part/ViewDetail.vue";
import {apiDeletePlant,apiGetPlantDetail,StationBasicInfo,StationInfo,StationCost,MonthHistory,OperationDelete,MeterUnconfigured} from "@/api/maintain/plant/list.js";
import * as maintainApi from "@/api/maintain/alarm/list.js";
import * as deviceApi from "@/api/device/alarm/list.js";

// import * as baseApi from '@/api/base'

export default {
	name:"alarm-info",
	components:{StatusIco,Checkbox,TagBox,InputText,AreaInput,Select,Confirm,Pagination,NoResult,Loading,Help,WindowForAlert,ViewDetail,FilterAdv},
	props:{
		type:{//1:电站；2:设备
			type:Number,
			default:null
		},
		userFor:{//用于电站或设备，采取不同的逻辑
			type:String,
			default:undefined//plant,device
		},
		// targetIdList:{//对象id
		// 	type:Array,
		// 	default:()=>[]
		// },
		plantIdList:{
			type:Array,
			default:()=>{[]}
		},
		deviceIdList:{
			type:Array,
			default:undefined
		},
		subSystemIdList:{
			type:Array,
			default:undefined
		},
		productId:{//设备的产品id
			type:String,
			default:undefined
		},
		searchText:{
			type:String,
			default:null
		},
		startTime:{
			type:Number,//sec
			default:null
		},
		timezone:{
			type:String,
			default:stage.time.timeZoneCode
		},
		alarmObjSelect:{//报警对象选择功能
			type:Boolean,
			default:true
		},
		powerTypeList:{//能源类型["PV","WIND"]
			type:Array,
			default:undefined
		}
	},
	data() {
		return {
			stage,
			option:{
				timeZoneCode:this.timezone||stage.time.timeZoneCode,
				startTime:this.startTime
			},
			floatColumn: ["a"],
			column: ["1", "2", "3", "4", "5"],
			searchTextInner:"",
			// selectQty:0,
			listMode: "list",
			statusCount:function(){
				let obj={};
				$.each(lib.getTypeText("","communicationStateS_plant_l",true),function(){
					obj[this.id[0]]=0;
				});
				obj.total=0;
				return obj;
			}(),
			filterQuick:{
				// xxxx:{
					// request:true,是否合并到请求数据中去
				// 	name:"",国际化文本，没有则不会创建筛选tag
				// 	def:,默认值
				// 	active:,生效值
				// 	tagKey:"",值翻译对照字段名(不设置则直接输出值)
				// 	parent:"",最终输出请求数据中所属上一级的字段名
				// 	type:""交互类型，并影响解析、重组数据
					// keyBefore:"xxxx."发出请求前将该字段名前附加字段的文本
				// }

				timeFilter:{
					request:true,//是否合并到请求数据中去
					name:"",
					def:"",//默认值
					active:"",//生效值
					list:[
					],
					targetMonth:new Date(new Date().getTime()-stage.time.localOffset+stage.time.offset),//选择的目标月
					tagKey:"",//值翻译对照字段名(不设置则直接输出值)
					parent:"",//最终输出请求数据中所属上一级的字段名
					type:"timeFilter"//交互类型，并影响解析、重组数据
				},
				name:{def:"",active:""},//搜索
				// statuses:{//状态
				// 	def:{1:false,2:false,3:false,99:false},
				// 	active:{
				// 		1:this.$route.query.quickType=="1"?true:false,
				// 		2:this.$route.query.quickType=="2"?true:false,
				// 		3:this.$route.query.quickType=="3"?true:false,
				// 		99:this.$route.query.quickType=="99"?true:false
				// 	},
				// }
				// followFlag:{def:false,active:false}//特别关注
			},
			// batchOperationList:[
			// 	{text:getLanguageStr('all2','批量操作'),value:"",def:getLanguageStr('all2','批量操作')},
			// 	{text:getLanguageStr('cmd259','批量关注'),value:"follow"},
			// 	{text:getLanguageStr('cmd260','批量解除关注'),value:"unfollow"},
			// 	{text:getLanguageStr('cmd44','批量关联'),value:"relevant"},
			// 	{text:getLanguageStr('cmd291','批量添加标签'),value:"addTag"}
			// ],
			filterAdv:{},
			// filterAdv:{
			// 	type:{
			// 		request:true,
			// 		name:getLanguageStr('word728','电站类型'),
			// 		def:null,
			// 		active:null,
			// 		tagKey:"plantType",
			// 		type:"radio"
			// 	},
			// 	gridInterconnectionType:{
			// 		request:true,
			// 		name:getLanguageStr('word736','并网类型'),
			// 		def:null,
			// 		active:null,
			// 		tagKey:"plantGridType",
			// 		type:"radio"
			// 	}
			// },
			filterAdvTemp:{
				// type:{
				// 	active:{1:false,2:false,3:false,4:false}
				// },
				type:{
					active:null
				},
				gridInterconnectionType:{
					active:null
				}
			},
			tagMap:{//用于记录生效的筛选条件
				// xxxx:{val:"",key:""}
			},

			pagination:{},//分页数据
			requestData:{},//api请求发送数据
			list:[],
			station:{},//电站详情
			basicInfo:{},//详情-电站信息
			basicCost:{},//详情-电站信息-电价
			associatedPerson:{},//关联人员
			"orderDirection":this.$route.query.orderDir||"DESC",//,ASC
			"orderProperty":this.$route.query.orderPpt||"alertTime",
			sourceType:'plant',
			filter:false,
		}
	},
	watch:{
		// "$route":function(route){//由于多路由调用同组件，直接到达不会触发生命流程，需要手动干预
		// 	// location.reload();
		// 	this.reset();
		// 	this.getList("clear");
		// },
		timezone:function(val){
			this.option.timeZoneCode=val;
		},
		"filterQuick.timeFilter.targetMonth":function(){
			this.selectAction(this.filterQuick.timeFilter.list.length-1,"timeFilter");
		},
		startTime:function(){//检测外部更新了开始时间
			this.option.startTime=this.startTime;
		}
		// searchTextInner:function(){
		// 	this.filterQuick.name.active=this.searchText;
		// }
	},
	methods: {
		getLanguageStr,
		getTypeText:lib.getTypeText,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
		operateModeChange:lib.operateModeChange, 
		timeFormat:lib.timeFormat,
		reset:function(){
			this.filterQuick.name.active="";
			this.filterQuick.timeFilter.active=this.filterQuick.timeFilter.def;
		},
		openD(obj, sourceType){
			console.log(obj)
			if(this.type ==2 ){
				statistic('A68', 'A37')
			}else{

			}
			if(lib.doPermissions('A/D/A2')){
				this.$refs.ViewDetail.show(obj, sourceType)
			} else {
				this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
			}
		},
		// showDevice(detailInfo){	//在本层呈现设备详情，关闭设备详情会导致报警详情windows的z-index失去独立层叠上下文，被总导航覆盖（移至报警详情的window中）
		// 	detailInfo.siteId=detailInfo.plantId;
		// 	this.$dynamic(this.$refs.view,DeviceDetail, {bg: true,type:this.type}, {
		// 	}, {}).then(({instance, childInstance}) => {
		// 		let dec = 1
		// 		if (detailInfo.deviceType === 'COLLECTOR') {
		// 			dec = 1
		// 		} else {
		// 			dec = 2
		// 		}
		// 		childInstance.show(detailInfo, '', instance, dec)
		// 	})
		// },
		// showPlant(detailInfo){	//在本层呈现电站详情，关闭电站详情会导致报警详情windows的z-index失去独立层叠上下文，被总导航覆盖（移至报警详情的window中）
		// 	this.$dynamic(this.$refs.view,PlantDetail, {bg: true}).then(({instance, childInstance}) => {
		// 		childInstance.show({id:detailInfo.plantId}, instance)	//instance 是否动态添加?以此决定是否销毁动态添加组件
		// 	})
		// },
		// view:function(clue,$e){
		// 	let $td=$($e.target).is("td")? $($e.target):$($e.target).parents("td").first();//定位td层
		// 	let qty=$td.find("label input").length;//获取复选框数量
		// 	if(qty==0){
		// 		this.$emit("View",clue.id);
		// 	}
		// },
		// selectData:function(val,index){
		// 	this.$emit("Select",val,index);
		// },
		getTypeText:lib.getTypeText,
		// timeFormat:function(sec,format){
		// 	let out=""; 
		// 	if(this.timeOffset){
		// 		out=lib.timeFormat(sec,'utc',format,{offset:this.timeOffset});
		// 	}
		// 	else out=lib.timeFormat(sec,'inc',format);
		// 	return out;
		// },
		transitionAction:lib.transitionAction,
		closeViewSys(){
			this.clueIsEmpty = true
		},
		filterAdvSync(sync=false){//同步高级筛选数据
			if(sync){//确定
				$.extend(true,this.filterAdv,this.filterAdvTemp);
			}else {
				$.extend(true,this.filterAdvTemp,this.filterAdv);//取消
			}
			// this.$nextTick(function(){
			// });
		},
		openFilterAdv(){
			this.filter=true
			setTimeout(()=>{
				// console.log(this.filterAdv)
				this.$refs.FilterAdv.show(this.filterAdv)
			},50)
			
			// this.getFilterMapArea();
			// this.filterAdvSync(false);
			// this.$refs.WindowForAlert.show();
		},
		searchList(data){
			this.filterAdv=data;
			this.getList(this.filterAdv,'filterAdv')
		},
		tagAction:function(){//$target,key
			// let app=this;
			this.$nextTick(()=>{
				if($.isEmptyObject(this.tagMap)) {
					$(this.$el).find(".filter .filterArea").stop().slideUp(200,function(){
						setTimeout(lib.fillHeight,200);
					});
				} else {
					$(this.$el).find(".filter .filterArea").stop().slideDown(200,"easeInOutExpo",function(){
						$(".filter .filterArea").css("height","");
						setTimeout(lib.fillHeight,200);
					});
				}
			});
		},
		show:function(sourceType, data){
			if(this.type==2) {
				this.sourceType = 'device'
			}
			this.getList();
		},
		getList:function(data,targetKey){
			let $this=this;
			this.$refs.Loading.show();
			if (data === "clear") {
				this.filterAdv={}
				// $.each(this.filterAdv,function (key,val){
				// 	if (this.displayVal!=undefined) this.displayVal=this.displayValDef;	//初始化显示值
				// 	if (this.fullList!=undefined) this.fullList=this.fullListDef;	//初始化给组件的TagBox循环对象传值
				// 	if ($.isPlainObject($this.filterAdv[key].active)||this.active != this.def){
				// 		if( $.isPlainObject($this.filterAdv[key].active) ) {//obj格式的继续遍历初始化值
				// 			$.each($this.filterAdv[key].active,function(k){
				// 				$this.$set($this.filterAdv[key].active,k,$this.filterAdv[key].def[k]);
				// 			});
				// 		}else if($.type($this.filterAdv[key].active)=="array"){//数组格式单独深拷贝，否则因为引用问题导致bug
				// 			$.extend(true,$this.filterAdv[key].active,$this.filterAdv[key].def);
				// 		}else $this.$set($this.filterAdv[key],"active",$this.filterAdv[key].def);
				// 	}
				// });

				this.$set(this,"tagMap",{});
				// this.$refs.SearchPerson.reset();	//关联人选择清空
			}else if ($.isPlainObject(data)) {//批量数据
				for(let attr in data){
					if($.isPlainObject(this[targetKey][attr].active)){
						$.extend(true,this[targetKey][attr].active,data[attr].active);
					}
					else{
						this[targetKey][attr].active=data[attr].active;
					}
				}
				if(data.hasOwnProperty('alarmObj')&& !data['alarmObj'].active){  //报警对象置空
					this.filterAdv.plantIdList.active=[]
					this.filterAdv.deviceIdList.active=[]
				}
			}
			this.timeDataReadyToDo(()=>{
				$.each(this.filterAdv,function(key,val){//处理高级筛选tag
					val=val.active;
					if(this.name){//仅有name的进行处理(filterAdv声明中定义)
						// app.$nextTick(function(){
							if (typeof(this.displayVal)!="undefined") {
								val=this.displayVal;
							}
							if($this.filterAdv[key].type=="checkbox"){//多选格式$.isPlainObject(val)
								let display="";
								//判断和默认值是否相同
								if(lib.objTool(this.active,"isSame",$this.filterAdv[key].def)==false){//不同则生成tag
									$.each(this.active,function(k,v){
										if(v){//&&!app.tagMap[k+v]
											if(display) display+=",";
											display+=lib.getTypeText(k,$this.filterAdv[key].tagKey);
											// $this.$set($this.tagMap,k+v,{val:k,key:key});
										}
										// $this.tagMap[key]={val:display,key};
										$this.$set($this.tagMap,key,{val:display,key});
									});
								}
								else{//相同则删除该tag
									$this.$delete($this.tagMap,key);
								}
								
							}else if($.inArray($.type(val),["string","number","boolean","null"])>=0){
								if(val){//&&!app.tagMap[key]
									$this.$set($this.tagMap,key,{val:val,key:key});
									// app.tagMap[key]={val:val,key:key};
								}else if(val==$this.filterAdv[key].def&&$this.tagMap[key]){//无效值且残留在tagMap，需要删除
									$this.$delete($this.tagMap,key);
								}
							}else if($.type(val)=="array"){
								if(val.join("")!=$this.filterAdv[key].def.join("")){//&&!app.tagMap[key]
									$this.$set($this.tagMap,key,{val:val.join(" "),key:key});
								}else if(val.join("")==$this.filterAdv[key].def.join("")&&$this.tagMap[key]){//无效值且残留在tagMap，需要删除
									$this.$delete($this.tagMap,key);
								}
							}
						// });
					}
				});
				if(data) this.$set(this.pagination.request,"page",1);

				this.tagAction();

				this.requestData={
					productId:this.productId,
					language:stage.languageId,
					plantIdList:this.plantIdList,
					deviceIdList:this.deviceIdList,
					powerTypeList:this.powerTypeList
				};
				function outData(targetData,type){//值处理，例如多选的格式仅输出有效的值
					switch(type){
						case "timeFilter":
							let startTime=0,endTime;
							let today,month,fullDay;
							if($this.option.startTime){
								today=new Date($this.option.startTime*1000);//-stage.time.localOffset
							}else{
								// today=Date.parse(new Date());
								// today=new Date(today-stage.time.localOffset+mz.tz($this.option.timeZoneCode)._offset*60*1000);
								today=new Date();
								// today=mz.tz(new Date(),$this.option.timeZoneCode)._d;
							}
							switch(targetData){
								case "a"://近10分钟
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d %H:%M:%S",{targetOffset:$this.option.timeZoneCode});
									$this.requestData.startTime=startTime-60*10;
									$this.requestData.endTime=startTime+60;

									// $this.requestData.startTime=new Date(today.getTime()-60*10*1000);
									// $this.requestData.endTime=today;

									// $this.requestData.startTime=lib.timeFormat(Math.floor(today.getTime()/1000-60*10),"api");
									// $this.requestData.endTime=lib.timeFormat(Math.floor(today.getTime()/1000),"api");
									break;
								case "b"://当日
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d",{targetOffset:$this.option.timeZoneCode});
									// startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d",{targetOffset:"America/Sao_Paulo"});
									// startTime=mz.tz(startTime,$this.option.timeZoneCode)._d.getTime();
									// trace(mz.tz($this.option.timeZoneCode).format("Z"),true);//America/Sao_Paulo
									$this.requestData.startTime=startTime;
									$this.requestData.endTime=$this.requestData.startTime+60*60*24-1;
									break;
								case "c"://近3日
									today=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d",{targetOffset:$this.option.timeZoneCode});
									endTime=today+60*60*24-1;
									$this.requestData.endTime=endTime;
									$this.requestData.startTime=today-(60*60*24*2);
									break;
								case "d"://近7日
									// endTime = Math.floor(today.getTime()/1000);
									// $this.requestData.endTime = endTime;
									// $this.requestData.startTime = endTime-(60*60*24*7)
									today=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d",{targetOffset:$this.option.timeZoneCode});
									endTime=today+60*60*24-1;
									$this.requestData.endTime=endTime;
									$this.requestData.startTime=today-(60*60*24*6);
									break;
								case "e"://当月
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode});
									$this.requestData.startTime=startTime;
									month=new Date(lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode})*1000).getMonth()+1;
									fullDay=new Date(lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode})*1000);
									fullDay.setMonth(month);
									fullDay.setDate(0);
									fullDay=fullDay.getDate();
									$this.requestData.endTime=lib.timeFormat(today,"targetZoneDateSec",`%Y-%m-${fullDay}`,{targetOffset:$this.option.timeZoneCode})+60*60*24-1;
									break;
								case "f"://选择月
									today=$this.filterQuick.timeFilter.targetMonth;
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode});
									$this.requestData.startTime=startTime;
									month=new Date(lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode})*1000).getMonth()+1;
									fullDay=new Date(lib.timeFormat(today,"targetZoneDateSec","%Y-%m-01",{targetOffset:$this.option.timeZoneCode})*1000);
									fullDay.setMonth(month);
									fullDay.setDate(0);
									fullDay=fullDay.getDate();
									$this.requestData.endTime=lib.timeFormat(today,"targetZoneDateSec",`%Y-%m-${fullDay}`,{targetOffset:$this.option.timeZoneCode})+60*60*24-1;
									// trace(today,true)
									break;
								case "g"://昨天
									today=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d",{targetOffset:$this.option.timeZoneCode});
									endTime=today+60*60*24-1;
									$this.requestData.endTime=endTime-(60*60*24*1);
									$this.requestData.startTime=today-(60*60*24*1);
									break;
								case "h"://当前-电站
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d %H:%M:%S",{targetOffset:$this.option.timeZoneCode});
									$this.requestData.startTime=($this.startTime||startTime)-60*7;
									$this.requestData.endTime=$this.startTime||startTime;
									break;

								case "i"://当前-设备
									startTime=lib.timeFormat(today,"targetZoneDateSec","%Y-%m-%d %H:%M:%S",{targetOffset:$this.option.timeZoneCode});
									$this.requestData.startTime=($this.startTime||startTime)-60*10;
									$this.requestData.endTime=($this.startTime||startTime)+60*10;
									break;
								// default:
								// 	break;
							}
							// console.log(new Date($this.requestData.startTime*1000),new Date($this.requestData.endTime*1000),mz.tz($this.option.timeZoneCode)._offset/60);
							targetData="pass";
							break;
						default:
							if( $.isPlainObject(targetData) ){//处理多选参数的字段
								let list=[];
								$.each(targetData,function(k){
									if(this&&Number(k)>=0) list.push(k);//key值小于0的不计，例如“全部”
								});
								targetData=list.length? list:null;
							}
							break;
					}
					return targetData;
				}
				$.each(this.filterQuick,function(key,val){//合并快速筛选中的所有条件
					let result=outData(this.active,this.type);
					if(result!="pass"&&(result||result!=$this.filterQuick[key].def)){
						if(this.parent){
							if($this.requestData[this.parent]==undefined) $this.requestData[this.parent]={};
							if(result!=null&&result!=$this.filterQuick[key].def) $this.requestData[this.parent][key]=result;
						}else if(this.keyBefore&&result&&result!=$this.filterQuick[key].def){
							$this.requestData[this.keyBefore+key]=result;
						}else{//没有上一级字段
							if(result!=$this.filterQuick[key].def) $this.requestData[key]=result;
						}
					}
				});
				$.each(this.filterAdv,function(key,val){//合并高级筛选中的所有条件
					if(this.request){
						let result=outData(this.active);
						if(result&&result!=$this.filterAdv[key].def){
							if(this.parent&&result&&result!=$this.filterAdv[key].def){
								if($this.requestData[this.parent]==undefined) $this.requestData[this.parent]={};
								$this.requestData[this.parent][key]=result;//if(result!=null&&result!=app.filterAdv[key].def)
							}else if(this.keyBefore&&result&&result!=$this.filterAdv[key].def){
								$this.requestData[this.keyBefore+key]=result;
							}else{//没有上一级字段
								if(result!=$this.filterAdv[key].def) $this.requestData[key]=result;
							}
						}
					}
				});
				// 报警电站和设备
				if(this.filterAdv.alarmObj && this.filterAdv.alarmObj.active){
					this.requestData.plantIdList = this.filterAdv.plantIdList.active.map(item=>item.id);
					if(this.filterAdv.deviceIdList.active.length>0){
						this.requestData.deviceIdList=this.filterAdv.deviceIdList.active.map(el=>el.id)
					}
					this.tagMap.alarmObj = {key:'alarmObj',val:this.filterAdv.alarmObj.active};
				}else{
					delete(this.tagMap.alarmObj);
				}
				// if(this.filterAdv.plantIdList && this.filterAdv.plantIdList.active.length>0 ){
				// 	this.requestData.plantIdList = this.filterAdv.plantIdList.active.map(item=>item.id);
				// 	this.tagMap.alarmObj = {key:'alarmObj',val:this.filterAdv.alarmObj.active};
				// } else if(this.filterAdv.deviceIdList && this.filterAdv.deviceIdList.active.length>0){
					
				// 	this.requestData.deviceIdList = this.filterAdv.deviceIdList.active.map(item=>item.id);
				// 	console.log(this.requestData.deviceIdList)
				// 	this.tagMap.alarmObj = {key:'alarmObj',val:this.filterAdv.alarmObj.active};
				// }else{
				// 	delete(this.tagMap.alarmObj);
				// }
				// let pagination={pagination:$.extend({},this.pagination.request,{order:this.order})};//合并分页数据//合并排序数据
				// pagination.pagination={...pagination.pagination,...};
				// this.requestData={...this.requestData,...this.pagination.request};

				// this._getClueList(this.requestData);
				if(this.requestData.deviceIdList&&this.requestData.deviceIdList.length==0) delete this.requestData.deviceIdList;
				if('plant' == this.sourceType){
					if(this.plantIdList){
						this.requestData.plantIdList=this.plantIdList
					}
					this.requestData={...this.requestData,groupIdList:this.subSystemIdList}
					maintainApi.apiGetList(this.orderDirection,this.orderProperty,this.pagination.request.size,this.pagination.request.page,this.requestData).then(success=>{
						// trace(success,true);
						this.list=success.total? success.data:null;
						this.pagination.total=this.statusCount.total=success.total;
						// app.$set(app.pagination,"total",success.total);
						let {total}=success;
						this.pagination={...this.pagination,...{total}};
						// app.pagination=$.extend(true,app.pagination,{total:success.total});
						this.$nextTick(function(){
							lib.fillHeight();
							this.$refs.Loading.hide();
						});
					},error=>{
						// error=$.parseJSON(error);
						// trace(error);
						!_.isEmpty(error) && this.$notify(error)
						// alert(error.error);
					});
				} else if('device' == this.sourceType) {
					this.requestData.deviceIdList=this.deviceIdList
					deviceApi.apiGetList(this.orderDirection,this.orderProperty,this.pagination.request.size,this.pagination.request.page,this.requestData).then(success=>{
						if(success.data) success.data.map(item=>{item.timezone = this.option.timeZoneCode})
						this.list=success.total? success.data:null;
						this.pagination.total=this.statusCount.total=success.total;
						let {total}=success;
						this.pagination={...this.pagination,...{total}};
						this.$nextTick(function(){
							lib.fillHeight();
							this.$refs.Loading.hide();
						});
					},error=>{
						!_.isEmpty(error) && this.$notify(error)
						this.$refs.Loading.hide();
					});
				}
			});
		},
		searchKey(){
			this.$set(this.pagination.request,"page",1);
			this.filterQuick.name.active=this.searchTextInner?this.searchTextInner:this.searchText
			this.getList()
		},
		afterClear(){
			if(this.requestData.name)this.searchKey()
		},
		onOrder:function(name){//排序动作
			if(this.orderProperty==name){
				if(this.orderDirection=="DESC") this.orderDirection="ASC";
				else this.orderDirection="DESC";
			}
			else{
				this.orderProperty=name;
				// this.orderDirection="ASC";
			}
			this.getList();
		},

		selectAction:function(i,type){
			switch(type){
				case "timeFilter":
					this.filterQuick.timeFilter.active=this.filterQuick.timeFilter.list[i].value;
					break;
			}
			this.getList();
		},
		selectData:function(val,index){
			let $this=this;
			if($.type(val)=="boolean"&&index>=0){
				this.list[index].isSelect=val;
			}else if(index=="all"){
				$.each(this.list,function(i){
					$this.$set($this.list[i],"isSelect",val);
				});
			}
			this.selectQty=this.list.filter(function(e){
				return e.isSelect;
			}).length;
			if(this.selectQty==this.list.length){
				// $(this.$refs.selectAll.$el).attr("status",2);
				this.selectAllStatus=2;
			}else if(this.selectQty>0){
				this.selectAllStatus=1;
			}else this.selectAllStatus=0;
		},
		timeDataReadyToDo:function(fn){
			if(this.type){//已知用于哪个部分
				let runFn;
				switch(this.type){
					case 1:
						runFn=async function(scope){//需要顺序执行，拿到必要数据后执行fn
							if(!scope.startTime){
								await StationInfo(scope.plantIdList[0]).then(success=>{
									// trace(success,true)
									scope.option.startTime=success.lastUpdateTime;
								},
								error=>{
									scope.$notify(error);
								});
							}
							if(!scope.timezone){
								await StationBasicInfo(scope.plantIdList[0]).then(success=>{
									// trace(success,true)
									scope.option.timezone=success.region.timezone;
								},
								error=>{
									scope.$notify(error);
								});
							}
							if(fn){
								return fn.apply(scope);
							}
						}(this);
						break;
					default:
						if(fn){
							return fn.apply(this);
						}
						break;
				}
			}
			else{
				if(fn){
					return fn.apply(this);
				}
			}
		},
		displayTime:function(time,format,offset){//根据不同场景进行时间处理
			if(this.timezone) offset=this.timezone;//优先使用传入or登录商家的时区
			return lib.timeFormat(time,'utc',format,{offset});
		},
		displaySelectTime:function(select){//处理快速筛选中目标月的显示
			let out="";
			if(select.token){
				out=getLanguageStr("cmd234","选择月")+"("+lib.timeFormat(this.filterQuick.timeFilter.targetMonth,"utc","%Y/%m",{offset:this.option.timeZoneCode})+")";
			}
			else{
				out=select.text;
			}
			return out;
		}
		//添加完后清除选择的select
		// clearSelect(){
		// 	let $this=this;
		// 	$.each(this.list,function(i){
		// 		$this.$set($this.list[i],"isSelect",false);
		// 	});
		// },
	},
	computed:{
		getTimeFilter:function(){
			let out=[];
			if(this.type){
				out=[
					(this.userFor=="plant"?{text:i18n.t("word1454",["当前"]),value:"h"}:{text:i18n.t("word1454",["当前"]),value:"i"}),
					{text:i18n.t("word1366",["当日"]),value:"b"},
					// {text:i18n.t("word1469",["昨日"]),value:"g"},
					{text:i18n.t("fill3rd117",[3,"近3天"]),value:"c"},
					{text:i18n.t("fill3rd117",[7,"近7日"]),value:"d"},
					{text:i18n.t("word1275",["当月"]),value:"e"},
					{text:i18n.t("cmd234",["选择月"]),value:"f",token:true}
				];
			}
			else{
				out=[
					// {text:i18n.t("fill3rd121",[10,"近10分钟"]),value:"a"},
					{text:i18n.t("word1366",["当日"]),value:"b"},
					// {text:i18n.t("word1469",["昨日"]),value:"g"},
					{text:i18n.t("fill3rd117",[3,"近3天"]),value:"c"},
					{text:i18n.t("fill3rd117",[7,"近7日"]),value:"d"},
					{text:i18n.t("word1275",["当月"]),value:"e"},
					{text:i18n.t("cmd234",["选择月"]),value:"f",token:true}
				];
			}
			this.filterQuick.timeFilter.def=this.filterQuick.timeFilter.active=out[0].value;//更新列表后设置默认值
			this.filterQuick.timeFilter.list=out;
			return out;
		}
		// returnTargetId:function(){
		// 	let out=undefined;
		// 	if(this.plantIdList) out=this.plantIdList[0];
		// 	else if(this.deviceIdList) out=this,deviceIdList[0];
		// 	return out;
		// }
	},
	created(){
		this.timeDataReadyToDo();
	},
	mounted(){
		// this.timezone=stage.time.timeZoneCode;
		if (this.$route.query.levelFirst) {
			if(this.$route.query.levelFirst=='level'){
				let activeData={0:false,1:false,2:false};
				activeData[this.$route.query.levelSecond]=true;
				this.filterAdv.levelList={
							request:true,
							name:getLanguageStr('word115','等级'),
							def:{0:true,1:true,2:true},
							active:activeData,
							tagKey:"alarmLevelFilter",
							type:"checkbox"
					}
			}else{
				let activeData={0:false,1:false,2:false,3:false};
				activeData[this.$route.query.levelSecond]=true
				this.filterAdv.influenceList={
					request:true,
					name:getLanguageStr('word1481','影响范围'),
					def:{0:true,1:true,2:true,3:true},
					active:activeData,
					tagKey:"alarmFilterScope",
					type:"checkbox"
				}
			}
		}
		this.tagAction();
		lib.fillHeight();
		lib.setScroll($(this.$el).find(".alarmList [scroll]"));
	}
}
</script>
<style lang="scss" scoped>
$operateMin:4em + 1;
$operateMax:4em * 5 + 1;
.operate{
	>*{width:$operateMax;}
	&[mode]{width:$operateMax;}
	&[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operateMax);}
	}
}
.bgEllipticBall{
    height: 2.2em;
    line-height: 2.2em;
    padding-left: 1em;
    display: inline-block;
    padding-right: 1em;
    border-radius: 1.1em;
    min-width: 7em;
}
.bgBall{
	    width: 3.5em;
    height: 3.5em;
    line-height: 3.5em;
    border-radius: 50%;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/alarm/part/List.vue